import { useState } from 'react';
import { Icon } from '../Icon';
import { NavigationControlledProps, NavigationProps } from '../Navigation';
import { NavigationItemProps } from '../Navigation/Item';
import { useLanguage } from '@/contexts/LanguageContext';

export type HeaderTopItemMobileProps = Omit<NavigationItemProps, keyof NavigationControlledProps | keyof NavigationProps>;

export const HeaderTopItemMobile = ({ onClick, icon, PopupComponent, hasPopup, ariaDescription }: HeaderTopItemMobileProps) => {
  const [showTopItemMobile, setShowTopItemMobile] = useState<boolean>(false);
  const { t } = useLanguage();
  return (
    <>
      <button
        className="flex items-center lg:hidden"
        onClick={onClick ?? (() => setShowTopItemMobile(true))}
        aria-haspopup={hasPopup && 'true'}
        aria-describedby={ariaDescription(t)}
      >
        {typeof icon !== 'function' && <Icon name={icon} className="w-5 h-5" />}
      </button>

      {PopupComponent && <PopupComponent visible={showTopItemMobile} onClose={() => setShowTopItemMobile(false)} />}
    </>
  );
};
